var map = {
	"./fancheering1.svg": 6935,
	"./fancheering2.svg": 48777,
	"./fancheering3.svg": 70029,
	"./fancheering4.svg": 72356,
	"./fancheering5.svg": 61882,
	"./rec-1.2.svg": 14979,
	"./team-1.3.svg": 18945,
	"./team-2.2.svg": 63486,
	"./team-3.4.svg": 84071,
	"./team-4.3.svg": 57741
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78301;